<template>
    <div class="animated fadeIn">
    
      <b-card no-body>
        <b-card-body>
          <b-row>
            <b-col lg="6">
              <b-form-group label="Sale From" label-cols-sm="4" label-cols-lg="3">
                <v-date-picker :formats='dateformats' v-model="fromDate" :input-props='{ class: "form-control" }' show-caps>
                </v-date-picker>
              </b-form-group>
    
            </b-col>
            <b-col lg="6">
              <b-form-group label="Sale To" label-cols-sm="4" label-cols-lg="3">
                <v-date-picker :formats='dateformats' v-model="toDate" :input-props='{ class: "form-control" }' show-caps>
                </v-date-picker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-button variant="primary" class="pull-right" @click="search" :disabled="fromDate > toDate">
                Search
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    
      <b-card no-body>
        <b-card-body>
   
        <br/>
          <b-row>
        
      <v-client-table :columns="columns" :data="products" :options="options" :theme="theme" id="dataTable" ref="dataTable">
      
      </v-client-table>
   
        </b-row>
    
    
        </b-card-body>
      </b-card>
    
    
    </div>
    
    </template>
    
    <script>
    import { mapState } from 'vuex'
    import Vue from 'vue'
    
    export default {
      name: 'SaleByRange',
      components: {
        
      },
      props: {
      systemid: {
        type: String,
        default: null,
      },
    },
      data: function() {
        return {
          fromDate: new Date(),
          toDate: new Date(),
          products: [],
          gridOptions : {},
          gridApi: null,         
          useVuex: false,
          theme: 'bootstrap4',
          template: 'default',
          columns: ['name','productSold', 'totalPrice'],
        options: {
          headings: {
            name: 'Product Name',
            productSold: 'Total Units Sold',
            totalPrice: 'Total Price',            
          },
          sortable: ['name'],
          filterable: ['name', 'productSold'],
          sortIcon: {
            base: 'fa',
            up: 'fa-sort-asc',
            down: 'fa-sort-desc',
            is: 'fa-sort'
          },
          pagination: {
            chunk: 5,
            edge: true,
            nav: 'scroll'
          },
          perPage: 25,

        },
        }
      },
      methods: {
    
      search() {
          this.products = []
          let params = {
            from: this.formatDate(this.fromDate),
            to: this.formatDate(this.toDate),
            systemid: this.systemid
          }
          Vue.axios.post('pos/getSaleByRange', params, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            this.products = response.data.data
            if(this.products.length > 0){
            this.columns =  ['name','productSold', 'totalPrice']
            }
            else{
            this.columns = [];
            }
            this.showSuccessMsg()
          })
          .catch ( error => {
            this.showErrorMsg()
          });
        },
    
    
      print() {
         this.gridApi.exportDataAsCsv({});
      }
      },
      created () {
      },
      mounted() {
      
    
      },
    
    }
    
    
    </script>
    